<template>
    <div id="tutorial" class="has-background-primary">
        <h1 class="title has-text-white">Hello</h1>
        <p class="subtitle has-text-white">Swipe up to watch our borrowers' pitch videos</p>
        <md-icon class="shake-vertical md-size-5x has-text-white">keyboard_arrow_up</md-icon>
    </div>
</template>

<script>
    export default {
        name: "home-tutorial"
    }
</script>

<style scoped>
    #tutorial {
        padding: 22% 8% 8%;
        height: 100%;
        border-radius: 22px;
    }

    .shake-vertical {
        margin-top: 14%;
        -webkit-animation: shake-vertical 3.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both;
        animation: shake-vertical 3.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both;
    }

    /* ----------------------------------------------
 * Generated by Animista on 2020-1-7 16:34:17
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

    /**
     * ----------------------------------------
     * animation shake-vertical
     * ----------------------------------------
     */
    @-webkit-keyframes shake-vertical {
        0%,
        100% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
        10%,
        30%,
        50%,
        70% {
            -webkit-transform: translateY(-8px);
            transform: translateY(-8px);
        }
        20%,
        40%,
        60% {
            -webkit-transform: translateY(8px);
            transform: translateY(8px);
        }
        80% {
            -webkit-transform: translateY(6.4px);
            transform: translateY(6.4px);
        }
        90% {
            -webkit-transform: translateY(-6.4px);
            transform: translateY(-6.4px);
        }
    }
    @keyframes shake-vertical {
        0%,
        100% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
        10%,
        30%,
        50%,
        70% {
            -webkit-transform: translateY(-8px);
            transform: translateY(-8px);
        }
        20%,
        40%,
        60% {
            -webkit-transform: translateY(8px);
            transform: translateY(8px);
        }
        80% {
            -webkit-transform: translateY(6.4px);
            transform: translateY(6.4px);
        }
        90% {
            -webkit-transform: translateY(-6.4px);
            transform: translateY(-6.4px);
        }
    }

</style>